import { z } from 'zod';

// BIGINT/NUMERIC do Postgres chega como string — coerção defensiva.
const num = z.coerce.number();
const numNull = z.coerce.number().nullable();
const strNull = z.string().nullable();

// ── Agente (catálogo + não-lidas do usuário) ─────────────────────────────────
export const agenteSchema = z.object({
  id: z.string(), // 'davi','rebeca','flora','jao'
  nome: z.string(),
  dominio: z.string(),
  cor: strNull,
  usa_canais: z.boolean(),
  ordem: num,
  nao_lidas: num,
  ultima_ts: strNull,
  ultima_preview: strNull,
});
export type Agente = z.infer<typeof agenteSchema>;
export const agenteListSchema = z.array(agenteSchema);

// ── Canal de um agente (+ conversa do usuário, se já existe) ──────────────────
export const canalSchema = z.object({
  id: num,
  slug: z.string(),
  nome: z.string(),
  icone: strNull, // 'hash' | 'logo:basa' | 'poly' | 'doc' | 'leaf' | 'sprout' | 'shield'
  ordem: num,
  conversa_id: numNull,
  nao_lidas: num,
  ultima_preview: strNull,
  ultima_ts: strNull,
});
export type Canal = z.infer<typeof canalSchema>;
export const canalListSchema = z.array(canalSchema);

// ── Conversa (get-or-create) ─────────────────────────────────────────────────
export const conversaSchema = z.object({
  id: num,
  user_id: num,
  agente_id: z.string(),
  canal_id: numNull,
  sessao_id: z.string(),
  nao_lidas: num,
  ultima_preview: strNull,
  ultima_ts: strNull,
  created_at: z.string(),
  updated_at: z.string(),
});
export type Conversa = z.infer<typeof conversaSchema>;

// ── Mensagem ──────────────────────────────────────────────────────────────────
export const mensagemTipo = z.enum(['texto', 'audio', 'foto', 'arquivo', 'localizacao', 'comando']);
export const mensagemPapel = z.enum(['user', 'assistant', 'system']);

export const mensagemSchema = z.object({
  id: num,
  papel: mensagemPapel,
  tipo: mensagemTipo,
  corpo: strNull,
  anexo_url: strNull,
  anexo_meta: z.unknown().nullable(),
  status: z.enum(['enviando', 'ok', 'erro']),
  ts: z.string(),
  created_at: z.string(),
});
export type Mensagem = z.infer<typeof mensagemSchema>;

export const mensagensPageSchema = z.object({
  mensagens: z.array(mensagemSchema),
  prox_cursor: strNull,
});
export type MensagensPage = z.infer<typeof mensagensPageSchema>;
